// extracted by mini-css-extract-plugin
export default {"three":"SecThree_three__CAgXn","main":"SecThree_main__2IAZ2","up":"SecThree_up__vjElK","down":"SecThree_down__gXNqE"};